import {
  compose,
  isTimeStringOrNullish,
} from '@monorepo/shared/utils/validators';
import React, { useMemo } from 'react';
import { useField, UseFieldConfig } from 'react-final-form';
import { TimePicker } from '../dateAndTimePickers';

type TimePickerFieldProps = Omit<
  React.ComponentProps<typeof TimePicker>,
  'value' | 'onChange' | 'error' | 'errorText'
> & {
  initialValue?: string;
  name: string;
  validate?: UseFieldConfig<string>['validate'];
  isLabelHidden?: boolean;
  dataFormat?: string;
  forceShowErrors?: boolean;
};

export function TimePickerField({
  name,
  validate,
  initialValue,
  dataFormat = 'HH:mm',
  forceShowErrors,
  ...rest
}: TimePickerFieldProps) {
  const composedValidate = useMemo(
    () =>
      validate
        ? compose(validate, isTimeStringOrNullish(dataFormat))
        : isTimeStringOrNullish(dataFormat),
    [validate, dataFormat],
  );

  const { input, meta } = useField<string>(name, {
    validate: composedValidate,
    initialValue,
  });

  const hasError =
    (forceShowErrors || meta.touched || meta.modified) && !!meta.error;
  return (
    <TimePicker
      {...rest}
      error={hasError}
      errorText={hasError ? meta.error : undefined}
      value={input.value}
      onChange={input.onChange}
      name={name}
      dataFormat={dataFormat}
    />
  );
}
